<mat-card class="mb-8 p-6">
  <div class="mb-4 text-lg font-medium">{{ fieldLabel }}:</div>
  <div [formGroup]="parentForm">
    <div formArrayName="shipments">
      <div [formGroupName]="shipmentIndex">
        <div class="flex flex-col md:flex-row md:items-center md:gap-6">
          <div class="flex-1 mb-2 md:mb-0">
            <mat-form-field appearance="fill" class="w-full">
              <input
                matInput
                [formControlName]="fieldName"
                [placeholder]="fieldLabel"
                [style.cursor]="'not-allowed'"
                readonly
              />
            </mat-form-field>
          </div>
          <div class="flex flex-row gap-2 items-end mb-2 md:mb-0">
            <button
              mat-flat-button
              color="primary"
              type="button"
              (click)="triggerFileInput()"
              [disabled]="isUploading() || viewDisable"
            >
              <ng-container *ngIf="isUploading(); else browseText">
                <mat-spinner diameter="20" class="inline-block align-middle"></mat-spinner>
              </ng-container>
              <ng-template #browseText>BROWSE</ng-template>
            </button>
            <input
              type="file"
              class="hidden"
              [id]="'fileInput-' + shipmentIndex + '-' + fieldName"
              (change)="onFileSelected($event)"
            />
            <button
              mat-flat-button
              color="accent"
              type="button"
              (click)="viewAttachment()"
              [disabled]="isUploading() || !shipmentGroup.get(fieldName)?.value"
            >
              VIEW
            </button>
            <button
              mat-icon-button
              color="warn"
              type="button"
              (click)="removeAttachment()"
              *ngIf="!viewDisable"
            >
              <mat-icon>delete</mat-icon>
            </button>
            <div *ngIf="uploadError()" class="text-red-600 text-xs mt-2 ml-1">
              {{ uploadError() }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-card>
